<template>
  <el-dialog
    :visible.sync="open"
    width="50%"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="status"
  >
    <div class="status__title">
      Изменение статуса для отчетов:
    </div>
    <div v-loading="loading">
      <div v-for="item in list" :key="item.id" class="status__report">
        <div class="status__report-block">№&nbsp;{{item.id}} / {{item.name}}</div>
        <div class="status__report-block">{{ currentStatus(item.status) }}</div>
      </div>
      <el-select
        v-model="newStatus"
        placeholder="Новый статус"
        class="status__select"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <span slot="footer">
      <el-button @click="closeModal">
        Отмена
      </el-button>
      <el-button
        type="primary"
        :disabled="newStatus.length === 0"
        @click="setChangedStatus"
      >
        Установить статус
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { statusOptions } from '../../constants'

const ReportsAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'StatusModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      statusOptions,
      newStatus: '',
      loading: false,
    }
  },
  methods: {
    async setChangedStatus() {
      this.loading = true
      try {
        const response = await ReportsAPI.changeReportsStatuses({
          report_ids: this.list.map(item => item.id),
          status: this.newStatus,
        })
        this.$message.success('Статус изменен')
        this.$emit('status-changed')
      } catch (e) {
        this.errHandler(e)
      } finally {
        this.loading = false
      }
    },
    currentStatus(status) {
      return this.statusOptions.find(item => item.value === status).label
    },
    closeModal() {
      this.newStatus = ''
      this.$emit('close-modal')
    },
  },
}
</script>

<style lang="sass" scoped>
@import "./modal-styles"
</style>
